function createLoadingNotificationSpinnerEl() {
  const loadingEl = document.createElement('div')
  loadingEl.classList.add('loading')
  loadingEl.classList.add('js-loading')
  const loadingImgEl = document.createElement('img')
  loadingImgEl.classList.add('loading__icon')
  loadingImgEl.setAttribute('src', '/images/loading.svg')
  loadingImgEl.setAttribute('width', '24')
  loadingImgEl.setAttribute('height', '24')
  loadingEl.appendChild(loadingImgEl)
  return loadingEl
}

export function addLoadingNotificationSpinnerEl(containerEl) {
  containerEl.appendChild(createLoadingNotificationSpinnerEl())
}

export function removeLoadingNotificationSpinnerEl(containerEl) {
  const loadingEl = containerEl.querySelector('.js-loading')
  if (loadingEl) {
    loadingEl.parentNode.removeChild(loadingEl)
  }
}

export function hideLoadMoreButtonEl(containerEl) {
  const loadMoreButtonEl = containerEl.querySelector(
    '.js-paginated-grid-load-more'
  )
  loadMoreButtonEl.classList.add('hidden')
}

export function showLoadMoreButtonEl(containerEl) {
  const loadMoreButtonEl = containerEl.querySelector(
    '.js-paginated-grid-load-more'
  )
  loadMoreButtonEl.classList.remove('hidden')
}
